import { render, staticRenderFns } from "./PurchasesViewerPopup.vue?vue&type=template&id=6d812661&scoped=true&lang=html"
import script from "./PurchasesViewerPopup.vue?vue&type=script&lang=js"
export * from "./PurchasesViewerPopup.vue?vue&type=script&lang=js"
import style0 from "./PurchasesViewerPopup.vue?vue&type=style&index=0&id=6d812661&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d812661",
  null
  
)

export default component.exports